/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const list = (st: SpanTag, searchTerm: string): Promise<APIResponse> => {
  let url = new URL(`${config.API_URL}/v1/tags`).toString();
  if (searchTerm) url = new URL(`?search=${searchTerm}`, url).toString();
  return fetchAPI(stleaf(st, 'ooge9n'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
